import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { Text } from 'hb-react/shared/components/formik/components/inputs';

export const Captcha = ({ image }: { image: string }) => (
  <Grid columnsInMobile mx={0} numCols={2}>
    <Row alignItems="center">
      <Col width={0.5}>
        <Text
          id="captcha"
          label={s__('JobForm|Enter code from the image')}
          name="captcha"
          placeholder={s__('JobForm|CAPTCHA code')}
          validate={{ maxLength: 6, minLength: 6, required: true }}
        />
      </Col>
      <Col width={0.5}>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: image }} />
      </Col>
    </Row>
  </Grid>
);
